export function getDataBySelector(attribute, key) {
    var _a;
    const element = document.querySelector(`[${attribute}]`);
    if (element === null) {
        return null;
    }
    return (_a = element.dataset[key]) !== null && _a !== void 0 ? _a : null;
}
